export const customelink = [
	{
		'title': 'مدارک و فایل های آموزشی',
		'icon': 'mx-3 fa fa-minus',
		'path': 'http://cz1.zarrinac.com/index.php/s/fVgbptX8cL7G94D',
		'module' : 'CustomeLinks'
	}
];
export const routes = [
	{
		'title': 'دستور کار',
		'icon': 'mx-3 fa fa-plus-circle',
		'hidden': 'loggedOut',
		'module' : 'Work_Orders',
		'children': [
			{
				'title': 'ایجاد دستورکار',
				'icon': 'mx-3 fa fa-minus',
				'path': '/dynamic/CreateWork_Orders',
			},
			{
				'title': 'لیست دستورکار',
				'icon': 'mx-3 fa fa-minus',
				'path': '/list/Work_Orders',
			},

		]
	},
	{
		'title': 'لیست درخواست کالا',
		'icon': 'fa fa-building',
		'path': '/list/Product_Request',
		'hidden': 'loggedOut',
		'module' : 'Product_Request',
	}
]